import { render } from "./FormBusinessHypothesis.vue?vue&type=template&id=59717f99"
import script from "./FormBusinessHypothesis.vue?vue&type=script&lang=js"
export * from "./FormBusinessHypothesis.vue?vue&type=script&lang=js"
script.render = render

export default script